import api from './api';

export const register = async (userData) => {
  // Register the user - no auto-login since email verification is required
  const registerResponse = await api.post('/auth/register', userData);
  return registerResponse.data;
};

export const login = async (email, password) => {
  try {
    // First, get the token
    // Note: OAuth2 spec requires the field to be called "username" even though we pass email
    const tokenResponse = await api.post('/auth/token', {
      username: email,  // API accepts email in the username field
      password
    }, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });

    // Store the token in localStorage
    const token = tokenResponse.data.access_token;
    localStorage.setItem('token', token);

    // Now, get the user data
    const userResponse = await api.get('/auth/me');

    return userResponse.data;
  } catch (error) {
    // Clear token if login fails
    localStorage.removeItem('token');
    throw error;
  }
};

export const logout = () => {
  localStorage.removeItem('token');
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const isAuthenticated = () => {
  return !!getToken();
};

// Function to check if the token is still valid
export const validateToken = async () => {
  const token = getToken();

  if (!token) {
    return false;
  }

  try {
    const response = await api.get('/auth/me');
    return !!response.data;
  } catch (error) {
    localStorage.removeItem('token');
    return false;
  }
};

// Check if a company with this email domain already exists
export const checkCompanyDomain = async (email) => {
  const response = await api.post('/auth/check-company-domain', { email });
  return response.data;
};

// Request access to an existing company
export const requestCompanyAccess = async ({ email, full_name, company_id, message }) => {
  const response = await api.post('/auth/request-company-access', {
    email,
    full_name,
    company_id,
    message
  });
  return response.data;
};